module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "kbx-form-footer"
  }, [_c('a', {
    staticClass: "kbx-btn",
    staticStyle: {
      "min-width": "100px"
    },
    style: (_vm.stepStyle('button')),
    attrs: {
      "klickbox-edit-item": "button",
      "klickbox-edit-label": _vm.$t('edit.canvas.redirect_button')
    }
  }, [_vm._v(_vm._s(_vm.stepPreview.redirect_button_text))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-c0effc7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/redirect/Button.vue
 ** module id = 905
 ** module chunks = 1
 **/